
import './App.css';
import { BrowserRouter, Route, Routes, Link} from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';



import Home from './components/Home';
import ChiSiamo from './components/Chisiamo';
import News from './components/News';
import Interventi from './components/Interventi'
import Foto from './components/Foto'

import { db } from "./components/firebase";
import { ref, get } from "firebase/database";


//img
//import logo from '/public/img/logo.png'
/*startServer();*/

function App() {

    const [menuAttivo, setMenuAttivo] = useState(null);
  
    const handleClick = (indice) => {
      setMenuAttivo(indice);
    };

    const [interventi, setInterventi] = useState([]); // Stato per i dati degli interventi
    const [loading, setLoading] = useState(true);

     useEffect(() => {
    const query = ref(db, "Interventi");
    const getData = async () => {
      try {
        const snapshot = await get(query);
        if (snapshot.val() !== null) {
          const data = snapshot.val();
          // Estrai gli oggetti "Intervento1", "Intervento2", ecc. dalla struttura dati "Interventi"
          const interventiArray = Object.values(data);
          // Inverti l'ordine degli articoli dal più recente al più antico
          const reversedInterventi = [...interventiArray].reverse();
          setInterventi(reversedInterventi);
          setLoading(false); // Imposta il loading a "false" dopo il caricamento
        } else {
          console.log("Nessun dato trovato");
          setLoading(false); // Imposta il loading a "false" anche in caso di dati non trovati
        }
      } catch (error) {
        console.error("Errore nel recupero dei dati:", error);
        setLoading(false); // Imposta il loading a "false" in caso di errore
      }
    };

    getData();
  }, []);
  
  return (
    <div className="App"><div className="All_box">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></link>
        <BrowserRouter>
          <header class="header">
            <div class="header-content">
              <div class="logo-title">
                <div class="logo">
                  <img src="/img/logo.png" alt="Logo" />
                </div>
                <div class="title-group">
                  <h1 class="title">Centro Zeta O.D.V.</h1>
                  <h2 class="subtitle">Protezione civile</h2>
                </div>
              </div>
            </div>
            <nav className="navigation">
              <ul>
                <li>
                  <Link
                    className={`menu ${menuAttivo === 0 ? 'menu-attivo' : ''}`}
                    to="/"
                    onClick={() => handleClick(0)}
                  >
                    Home
                  </Link>
                </li>
                <li>
                  <Link
                    className={`menu ${menuAttivo === 1 ? 'menu-attivo' : ''}`}
                    to="/ChiSiamo"
                    onClick={() => handleClick(1)}
                  >
                    Chi Siamo
                  </Link>
                </li>
                <li>
                  <Link
                    className={`menu ${menuAttivo === 2 ? 'menu-attivo' : ''}`}
                    to="/News"
                    onClick={() => handleClick(2)}
                  >
                    News
                  </Link>
                </li>
                <li>
                  <Link
                    className={`menu ${menuAttivo === 3 ? 'menu-attivo' : ''}`}
                    to="/Interventi"
                    onClick={() => handleClick(3)}
                  >
                    Interventi
                  </Link>
                </li>
                <li>
                  <Link
                    className={`menu ${menuAttivo === 4 ? 'menu-attivo' : ''}`}
                    to="/Foto"
                    onClick={() => handleClick(4)}
                  >
                    Foto
                  </Link>
                </li>
              </ul>
            </nav>
          </header>
          <Routes>
            <Route path="/" element={<Home />} ></Route>
            <Route path="/ChiSiamo" element={<ChiSiamo />}/>
            <Route path="/News" element={<News/>}/>
            <Route path="/Interventi" element={<Interventi />}/>
            <Route path ="/Foto" element={<Foto />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>

        
        <footer class="footer">
          <div class="footer_header">
            <p style={{fontSize:"0.7rem"}}>Iscritta nel Registro Regionale del Volontariato della Regione Lazio con decreto N°25 del 21 Agosto 2013</p>
            <p style={{fontSize:"0.7rem"}}>Iscritta Albo Protezione Civile Regione Lazio N°1041 del 1991</p>
            <p></p>
          </div>
          <div class="footer-content">
          <div class="footer-section">
            <p class="sub_voice">Indirizzo: via Giuseppe Beduschi 63, Roma</p>
            <p class="sub_voice">Telefono: <a href='tel:+3496695089'>3496695089</a> <a href='tel:+3476500832'>3476500832</a></p>
            <p class="sub_voice">Email: <a href="mailto:info@centrozeta.it">info@centrozeta.it</a></p>
            <p class="sub_voice">PEC: <a href="mailto:segreteria@pec.centrozeta.it">segreteria@pec.centrozeta.it</a></p>
          </div>
            <div class="footer-section">
              <ul class="social-links">
                <li><a href="https://www.instagram.com/centro_zeta/?hl=it" target="_blank"><i class="fa fa-instagram"></i></a></li>
                <li><a href="https://www.facebook.com/ProtezioneCivileCentroZeta/" target="_blank"><i class="gg-facebook"></i></a></li>
              </ul>
            </div>
            <div class="footer-section">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2974.808118846734!2d12.349159475344281!3d41.78934877096725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1325f3e1556daeb1%3A0x1564204d50f60f14!2sAss.%20Volontari%20Protezione%20Civile%20Centro%20Zeta!5e0!3m2!1sit!2sit!4v1697131681104!5m2!1sit!2sit" className='maps' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </footer>    
    </div></div>
  );
}

export default App;
